/*
 * This file is main entry point for main site js
 */
define("entry-main", [
    "jquery",
    "@modules/custom.ui",
    "knockout",
    "bootstrap",
    "@modules/alerts",
    "@modules/auto-form-submit",
    "@modules/campaignContact",
    "@modules/chat/orbitachatbot",
    "@modules/chat/mindfulcallbackwidget",
    "@modules/collectEmail",
    "@modules/communicationPreferences",
    "@modules/confirmAccount",
    "@modules/content/enrollment/guidedEnrollmentForm",
    "@modules/content/enrollment/pcpToEnrollmentForm",
    "@modules/content/helpfulBlockOverlay/helpfulBlockOverlay",
    "@modules/content/newsletter/newsletter",
    "@modules/content/salesEvent/findSeminarCta",
    "@modules/content/salesEvent/salesEventDialog",
    "@modules/content/salesEvent/seminarSearch",
    "@modules/countdownBanner",
    "@modules/CTAModal",
    "@modules/editMember",
    "@modules/enrollmentLeadForm",
    "@modules/eventsResults",
    "@modules/exitConfirmationDialog",
    "@modules/externalLinkConfirm",
    "@modules/fitbitOrderFormValidation",
    "@modules/getMember",
    "@modules/helpCategories",
    "@modules/helpLoggingIn",
    "@modules/iframeResize",
    "@modules/inputmask/customInputMasks",
    "@modules/interactiontracker/interactionTracker",
    "@modules/interop/interop-global",
    "@modules/interop/interop-timeout",
    "@modules/introjs",
    "@modules/languageSelector",
    "@modules/loginValidation",
    "@modules/multiLineCharacterCount",
    "@modules/myDocuments",
    "@modules/myDocumentsV3",
    "@modules/myMaterials",
    "@modules/overlay",
    "@modules/pdfJobManager",
    "@modules/pdfLinks",
    "@modules/personalization",
    "@modules/planMaterialsSearch",
    "@modules/planFinder",
    "@modules/redirectToPdfGeneration",
    "@modules/registrationValidation",
    "@modules/services/dataLayerService",
    "@modules/session-timeout",
    "@modules/site-search",
    "@modules/stateSelector",
    "@modules/timeoutModal",
    "@modules/tools/formulary-search/formularyDetail",
    "@modules/tools/formulary-search/formularySearch",
    "@modules/tools/hospital-search/hospitalSearch",
    "@modules/tools/pharmacy-search/pharmacySearch",
    "@modules/tools/provider-search/providerSearch",
    "@modules/tools/snf-search/snfSearch",
    "@modules/tools/facility-search/facilitySearch",
    "@modules/utils",
    "jquery-inputmask",
    "underscore"
], function ($, ui, ko) {
    $(function () {
        ui();
        window.ko = ko;
        setTimeout(function () {
            console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
            console.log(" Main site js!");
            console.log("                                             " + new Date());
            console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
        }, 1500);
    });
});
